// Keyboard navigation for dropdown menus
document.addEventListener('DOMContentLoaded', () => {
    // Prevent duplicate tab stops in primary nav (focus should land on links, not li wrappers)
    const clearNavListItemTabindex = () => {
        document
            .querySelectorAll('.menu-primary-list li[tabindex]')
            .forEach((menuListItem) => menuListItem.removeAttribute('tabindex'));
    };

    clearNavListItemTabindex();

    const menuRoot = document.querySelector('.menu-primary-list');
    if (menuRoot) {
        new MutationObserver(() => {
            clearNavListItemTabindex();
        }).observe(menuRoot, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['tabindex'],
        });
    }

    // Get all menu items with children
    const menuItemsWithChildren = document.querySelectorAll(
        '.menu-primary-list > li.menu-item-has-children'
    );

    menuItemsWithChildren.forEach((menuItem) => {
        const parentLink = menuItem.querySelector(':scope > a');
        const submenu = menuItem.querySelector(':scope > .sub-menu');

        if (!parentLink || !submenu) return;

        // Track timeout for blur handling
        let blurTimeout = null;

        // Show submenu on focus
        parentLink.addEventListener('focus', () => {
            if (blurTimeout) clearTimeout(blurTimeout);
            submenu.classList.add('show');
        });

        // Hide submenu on blur, with delay to allow moving focus into submenu
        parentLink.addEventListener('blur', () => {
            blurTimeout = setTimeout(() => {
                submenu.classList.remove('show');
                blurTimeout = null;
            }, 100);
        });

        // If user tabs to a submenu link, keep the submenu open
        const submenuLinks = submenu.querySelectorAll(':scope > li > a');
        submenuLinks.forEach((link) => {
            link.addEventListener('focus', () => {
                if (blurTimeout) clearTimeout(blurTimeout);
                submenu.classList.add('show');
            });

            link.addEventListener('blur', (e) => {
                // If the next focused element is not within this submenu, hide it
                blurTimeout = setTimeout(() => {
                    if (!submenu.contains(document.activeElement)) {
                        submenu.classList.remove('show');
                    }
                    blurTimeout = null;
                }, 100);
            });
        });
    });

    // Fix ARIA issues on Splide carousels
    // Run once after full page load so Splide has finished initialization.
    const removeSplideSlideGroupRole = (root = document) => {
        root.querySelectorAll('.splide__slide[role="group"]').forEach((slide) => {
            slide.removeAttribute('role');
        });
    };

    window.addEventListener('load', () => removeSplideSlideGroupRole(), { once: true });

    // Keep "View Site" link immediately after main nav in keyboard order
    const getViewSiteLink = () => {
        const sidebar = document.querySelector('.sidebar-sticky');
        if (!sidebar) return null;

        return (
            Array.from(sidebar.querySelectorAll('a')).find((link) => {
                const ariaLabel = link.getAttribute('aria-label');
                return ariaLabel && ariaLabel.trim().toLowerCase() === 'view site';
            }) || null
        );
    };

    const placeViewSiteAfterNav = () => {
        const navLinks = document.querySelectorAll('.menu-primary-list > li > a[tabindex]');
        const viewSiteLink = getViewSiteLink();

        if (!navLinks.length || !viewSiteLink) return;

        let maxNavTabIndex = -1;
        navLinks.forEach((link) => {
            const tabIndexValue = Number.parseInt(link.getAttribute('tabindex'), 10);
            if (!Number.isNaN(tabIndexValue)) {
                maxNavTabIndex = Math.max(maxNavTabIndex, tabIndexValue);
            }
        });

        if (maxNavTabIndex >= 0) {
            viewSiteLink.setAttribute('tabindex', String(maxNavTabIndex + 1));
        }
    };

    // Run on initial load and after any layout shifts
    placeViewSiteAfterNav();
    requestAnimationFrame(placeViewSiteAfterNav);
    window.addEventListener('load', placeViewSiteAfterNav, { once: true });

    // Keep keyboard focus visible inside people grid cards
    const peopleGrid = document.querySelector('.people-grid');
    if (!peopleGrid) return;

    let isTabbing = false;
    const topBand = 0.2;
    const bottomBand = 0.8;

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Tab') isTabbing = true;
    });

    document.addEventListener('mousedown', () => {
        isTabbing = false;
    });

    peopleGrid.addEventListener('focusin', (event) => {
        if (!isTabbing || !event.target || event.target.nodeType !== 1) return;

        const focusContainer = event.target.closest('.person-card') || event.target;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const containerRect = focusContainer.getBoundingClientRect();

        const topThreshold = viewportHeight * topBand;
        const bottomThreshold = viewportHeight * bottomBand;
        if (containerRect.top >= topThreshold && containerRect.bottom <= bottomThreshold) return;

        const centeredTop =
            window.scrollY +
            containerRect.top -
            (viewportHeight / 2 - containerRect.height / 2);
        const maxScrollTop = document.documentElement.scrollHeight - viewportHeight;
        const targetTop = Math.max(0, Math.min(centeredTop, maxScrollTop));

        window.scrollTo({ top: targetTop, behavior: 'auto' });
    });
});